import React from 'react';
import { Link } from 'react-router-dom';
import './LegalPages.css';

const PrivacyPolicy = () => {
  return (
    <div className="legal-page">
      <header className="landing-page__header">
        <div className="landing-page__logo-container">
          <Link to="/">
            <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="AIvatar Logo" className="landing-page__logo" />
          </Link>
        </div>
      </header>
      
      <main className="legal-page__content container">
        <h1>PRIVACY POLICY</h1>
        
        <section className="legal-page__section">
          <h2>1. INTRODUCTION</h2>
          <p><strong>Business Name</strong>: BOCO<br />
          <strong>RCS (Trade and Companies Register) Number</strong>: 895311082<br />
          <strong>Status</strong>: Sole Proprietorship<br />
          <strong>SIRET Number</strong>: 89531108200021<br />
          <strong>Address</strong>: Les Catalas, 09700 Saverdun France<br />
          <strong>Phone Number</strong>: 0756835116<br />
          <strong>E-mail</strong>: contact@muware.xyz<br />
          <strong>Publication Manager's E-mail</strong>: contact@muware.xyz</p>
          
          <p>This Privacy Policy describes how BOCO ("we," "us," or "our") collects, uses, and shares your personal information when you use our AI avatar creation service (the "Service"). We respect your privacy and are committed to protecting your personal data. This Privacy Policy also tells you about your privacy rights and how the law protects you.</p>
        </section>
        
        <section className="legal-page__section">
          <h2>2. DATA WE COLLECT</h2>
          
          <h3>2.1. Information You Provide to Us:</h3>
          <ul>
            <li><strong>Account Information</strong>: When you register, we collect your name, email address, and password.</li>
            <li><strong>Payment Information</strong>: When you make a purchase, our payment processor (Stripe) collects your payment details. We do not store complete payment information on our servers.</li>
            <li><strong>Images</strong>: We collect the photos you upload for avatar generation.</li>
            <li><strong>Communications</strong>: When you contact us, we collect the information you provide in your communications.</li>
          </ul>
          
          <h3>2.2. Information Collected Automatically:</h3>
          <ul>
            <li><strong>Usage Data</strong>: We collect information about how you interact with our Service, including pages visited, features used, and time spent.</li>
            <li><strong>Device Information</strong>: We collect information about your device, including IP address, browser type, operating system, and device identifiers.</li>
            <li><strong>Cookies and Similar Technologies</strong>: We use cookies and similar tracking technologies to collect information about your browsing activities.</li>
          </ul>
        </section>
        
        <section className="legal-page__section">
          <h2>3. HOW WE USE YOUR DATA</h2>
          
          <p>We use your personal data for the following purposes:</p>
          
          <h3>3.1. To Provide Our Service:</h3>
          <ul>
            <li>Process and fulfill your avatar generation requests</li>
            <li>Manage your account</li>
            <li>Process payments</li>
            <li>Send transactional messages, including delivery of generated avatars</li>
            <li>Provide customer support</li>
          </ul>
          
          <h3>3.2. To Improve and Develop Our Service:</h3>
          <ul>
            <li>Analyze usage patterns and trends</li>
            <li>Test and develop new features</li>
            <li>Troubleshoot issues</li>
          </ul>
          
          <h3>3.3. For Marketing and Communication:</h3>
          <ul>
            <li>Send promotional emails about new services, features, or other news</li>
            <li>Conduct surveys or request feedback</li>
            <li>Display personalized advertisements</li>
          </ul>
          
          <h3>3.4. For Security and Legal Compliance:</h3>
          <ul>
            <li>Detect and prevent fraud, spam, abuse, security incidents</li>
            <li>Comply with legal obligations</li>
            <li>Enforce our Terms of Service</li>
          </ul>
        </section>
        
        <section className="legal-page__section">
          <h2>4. HOW WE STORE AND PROCESS YOUR DATA</h2>
          
          <h3>4.1. Data Storage:</h3>
          <ul>
            <li>Your personal data is stored on servers hosted by OVH, located in Europe.</li>
            <li>Your uploaded images are temporarily stored only for the purpose of generating avatars and are deleted from our servers once processing is complete.</li>
          </ul>
          
          <h3>4.2. Data Retention:</h3>
          <ul>
            <li>Account information is retained as long as you maintain an active account with us.</li>
            <li>Payment information is retained for accounting and legal purposes for the duration required by law.</li>
            <li>Usage data may be retained for analytical purposes for up to 24 months.</li>
          </ul>
          
          <h3>4.3. Data Security:</h3>
          <ul>
            <li>We implement appropriate technical and organizational measures to protect your personal data from unauthorized access, alteration, disclosure, or destruction.</li>
            <li>We regularly review and update our security practices to enhance protection.</li>
          </ul>
        </section>
        
        <section className="legal-page__section">
          <h2>5. DATA SHARING AND THIRD PARTIES</h2>
          
          <h3>5.1. Service Providers:</h3>
          <ul>
            <li><strong>Payment Processing</strong>: We use Stripe to process payments.</li>
            <li><strong>Hosting Services</strong>: We use OVH for hosting our service and data.</li>
            <li><strong>Email Services</strong>: We may use third-party email service providers to send transactional and marketing emails.</li>
          </ul>
          
          <h3>5.2. Analytics and Advertising Partners:</h3>
          <ul>
            <li><strong>Google Analytics</strong>: We use Google Analytics to understand how users interact with our Service.</li>
            <li><strong>Facebook Pixel</strong>: We use Facebook Pixel to measure the effectiveness of our advertising and to serve targeted advertisements.</li>
            <li><strong>TikTok Pixel</strong>: We use TikTok Pixel for advertising campaign measurement and audience targeting.</li>
          </ul>
          
          <h3>5.3. Legal Requirements:</h3>
          <p>We may disclose your personal data if required to do so by law or in response to valid requests by public authorities (e.g., a court or government agency).</p>
        </section>
        
        <section className="legal-page__section">
          <h2>6. YOUR PRIVACY RIGHTS</h2>
          
          <p>Depending on your location, you may have certain rights regarding your personal data:</p>
          
          <h3>6.1. For EU/EEA Residents (GDPR):</h3>
          <ul>
            <li><strong>Right to Access</strong>: You can request a copy of the personal data we hold about you.</li>
            <li><strong>Right to Rectification</strong>: You can request correction of any inaccurate personal data.</li>
            <li><strong>Right to Erasure</strong>: You can request deletion of your personal data under certain circumstances.</li>
            <li><strong>Right to Restrict Processing</strong>: You can request restrictions on how we process your data.</li>
            <li><strong>Right to Data Portability</strong>: You can request a copy of your data in a structured, machine-readable format.</li>
            <li><strong>Right to Object</strong>: You can object to our processing of your personal data under certain circumstances.</li>
            <li><strong>Right to Withdraw Consent</strong>: You can withdraw your consent at any time where we rely on consent to process your data.</li>
          </ul>
          
          <h3>6.2. For California Residents (CCPA/CPRA):</h3>
          <ul>
            <li><strong>Right to Know</strong>: You can request information about the personal data we collect, use, disclose, and sell.</li>
            <li><strong>Right to Delete</strong>: You can request deletion of your personal data, subject to certain exceptions.</li>
            <li><strong>Right to Opt-Out</strong>: You can opt-out of the sale of your personal data.</li>
            <li><strong>Right to Non-Discrimination</strong>: We will not discriminate against you for exercising your privacy rights.</li>
          </ul>
          
          <h3>6.3. How to Exercise Your Rights:</h3>
          <p>To exercise any of these rights, please contact us at contact@muware.xyz. We will respond to your request within the timeframe required by applicable law.</p>
        </section>
        
        <section className="legal-page__section">
          <h2>7. COOKIES AND TRACKING TECHNOLOGIES</h2>
          
          <h3>7.1. Cookies We Use:</h3>
          <ul>
            <li><strong>Essential Cookies</strong>: Necessary for the Service to function properly.</li>
            <li><strong>Preference Cookies</strong>: Enable the website to remember your preferences.</li>
            <li><strong>Analytics Cookies</strong>: Help us understand how visitors interact with our website.</li>
            <li><strong>Marketing Cookies</strong>: Used to track visitors across websites to display relevant advertisements.</li>
          </ul>
          
          <h3>7.2. Your Cookie Choices:</h3>
          <ul>
            <li>Most web browsers allow control of cookies through browser settings.</li>
            <li>You can opt-out of Google Analytics by installing the Google Analytics Opt-out Browser Add-on.</li>
            <li>You can manage your Facebook ad preferences through your Facebook account settings.</li>
            <li>You can manage your TikTok ad preferences through your TikTok account settings.</li>
          </ul>
        </section>
        
        <section className="legal-page__section">
          <h2>8. EMAIL MARKETING</h2>
          
          <h3>8.1. Marketing Communications:</h3>
          <ul>
            <li>When you make a purchase, your email may be added to our marketing list.</li>
            <li>We will send transactional emails related to your purchase and avatar delivery.</li>
            <li>We may also send promotional emails about new features, services, or offers.</li>
          </ul>
          
          <h3>8.2. Opting Out:</h3>
          <ul>
            <li>You can unsubscribe from our marketing emails at any time by clicking the "unsubscribe" link included in every marketing email.</li>
            <li>Opting out of marketing communications does not affect transactional emails related to your purchases or account.</li>
          </ul>
        </section>
        
        <section className="legal-page__section">
          <h2>9. CHILDREN'S PRIVACY</h2>
          <p>Our Service is not intended for children under the age of 18. We do not knowingly collect personal data from children under 18. If you are a parent or guardian and believe your child has provided us with personal data, please contact us, and we will delete such information from our systems.</p>
        </section>
        
        <section className="legal-page__section">
          <h2>10. INTERNATIONAL DATA TRANSFERS</h2>
          <p>We primarily store and process your data within the European Union. However, some of our service providers may process personal data outside of the EU. In such cases, we ensure appropriate safeguards are in place to protect your information.</p>
        </section>
        
        <section className="legal-page__section">
          <h2>11. CHANGES TO THIS PRIVACY POLICY</h2>
          <p>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last updated" date.</p>
          <p>It is advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.</p>
        </section>
        
        <section className="legal-page__section">
          <h2>12. CONTACT US</h2>
          <p>If you have any questions about this Privacy Policy or our data practices, please contact us:</p>
          <p>
            By email: contact@muware.xyz<br />
            By mail: BOCO, Les Catalas, 09700 Saverdun France
          </p>
        </section>
        
        <p className="legal-page__last-updated">Last updated: May 1, 2025</p>
      </main>
      
      <footer className="footer">
        <div className="container">
          <p>© 2025 AIvatar. All rights reserved.</p>
          <div className="footer-links">
            <Link to="/terms-of-service">Terms of Service</Link>
            <Link to="/privacy-policy">Privacy Policy</Link>
            <a href="mailto:contact@muware.xyz">Contact Us</a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default PrivacyPolicy; 